import styled, { css } from "styled-components";

import contrastColor from "../utils/contrastColor";

const CssDefaultInteractive = css`
    &:enabled:hover {
        opacity: .7;
    }
`;

const CssDefault = css`
    background: ${ ({ accent, color }) => color ?? contrastColor(accent) };
    border: 1px solid transparent;
    border-radius: 2px;
    color: ${ ({ accent, color }) => accent ?? contrastColor(color) };

    &:disabled {
        opacity: .5;
    }

    ${ ({ disabled, locked }) => !disabled && !locked && CssDefaultInteractive }
`;

const CssOutlineInteractive = css`
    &:enabled:hover {
        opacity: .6;
    }
`;

const CssOutline = css`
    background: transparent;
    border: 1px solid ${ ({ color }) => color };
    border-radius: 2px;
    color: ${ ({ color }) => color };

    ${ ({ disabled, locked }) => !disabled && !locked && CssOutlineInteractive }
`;

const CssTextInteractive = css`
    text-decoration: underline;

    &:enabled:hover {
        box-shadow: inset 0 -.6em 0 0 ${ ({ color, accent }) => accent ?? contrastColor(color) };
        text-decoration: none;
    }
`;

const CssTextToggle = css`
    box-shadow: inset 0 -.6em 0 0 ${ ({ color, accent }) => accent ?? contrastColor(color) };
    text-decoration: none;
`;

const CssText = css`
    background: transparent;
    color: ${ ({ accent, color }) => color ?? contrastColor(accent) };
    padding: 0 2px;
    transition: box-shadow 100ms;

    ${ ({ disabled, locked }) => !disabled && !locked && CssTextInteractive }
    ${ ({ toggled }) => toggled && CssTextToggle }
`;

const CssSmall = css`
    padding: 4px 12px;
`;

const CssMedium = css`
    padding: 8px 16px;
`;

const CssLarge = css`
    padding: 12px 32px;
`;

export default styled.button.attrs(
    (attrs) => (
        {
            color: attrs.color ?? "#000",
            size: attrs.size ?? "medium",
            variant: attrs.variant ?? "default",
        }
    )
)`
    border: none;
    font-family: var(--font-mono), monospace;
    font-size: 1rem;

    &:enabled:hover {
        cursor: pointer;
    }

    ${ ({ size }) => size === "small" && CssSmall }
    ${ ({ size }) => size === "medium" && CssMedium }
    ${ ({ size }) => size === "large" && CssLarge }

    ${ ({ variant }) => variant === "default" && CssDefault }
    ${ ({ variant }) => variant === "outline" && CssOutline }
    ${ ({ variant }) => variant === "text" && CssText }
`;
